import React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { KeyboardArrowDownRounded } from "@mui/icons-material";

export default function Select(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    options,
    error = null,
    showNA = false,
    ...other
  } = props;
  return (
    <FormControl variant={variant || "filled"} {...other}>
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        IconComponent={(e) => <KeyboardArrowDownRounded {...e} />}
        MenuProps={{ classes: { paper: "shadow-sm" } }}
        {...(error && { error: true })}
      >
        {showNA && (
          <MenuItem value="">
            <em>N/A</em>
          </MenuItem>
        )}
        {options.map((item, index) =>
          item.Subheader !== undefined ? (
            <ListSubheader
              disabled
              sx={{
                position: "relative",
                color: "#000",
                fontStyle: "italic",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
              key={index}
              value=""
            >
              <em>{item.Subheader}</em>
            </ListSubheader>
          ) : (
            <MenuItem key={index} value={item.id}>
              {item.name}
            </MenuItem>
          )
        )}
      </MuiSelect>
      {error && (
        <FormHelperText className="error-color">{error}</FormHelperText>
      )}
    </FormControl>
  );
}
